module.exports = __webpack_public_path__ + "images/柏纳s长图_08-3.jpg?v=0b020db3";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan2/柏纳s长图_08-3.jpg
 ** module id = 169
 ** module chunks = 1 2
 **/